import PropTypes from 'prop-types';

import MortgageCalculatorEnhanced from './mortgage-calculator-enhanced';
import RentVsBuyCalculator from './rent-vs-buy-calculator';
import AffordabilityCalculator from './affordability-calculator';
import RefinanceCalculator from './refinance-calculator';

const Calculators = ({ config, title, ...props }) => {
  const { type, hideVisual = false, description, condensed = false } = config || {};

  // Map calculator type to component
  const calculatorMap = {
    Mortgage: MortgageCalculatorEnhanced,
    RentVsBuy: RentVsBuyCalculator,
    Affordability: AffordabilityCalculator,
    Refinance: RefinanceCalculator
  };

  const CalculatorComponent = calculatorMap[type];

  if (!CalculatorComponent) {
    console.error(`Calculator type "${type}" is not supported.`);
    return null;
  }

  // Pass all props to the calculator, but hide the selector for CMS usage
  // Allow title from Snippet and description from config to override defaults
  // condensed mode can be set via config for embedded/snippet usage
  return (
    <CalculatorComponent
      {...props}
      showCalculatorSelector={false}
      hideVisual={hideVisual}
      condensed={condensed}
      title={title}
      description={description}
    />
  );
};

Calculators.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.oneOf(['Mortgage', 'RentVsBuy', 'Affordability', 'Refinance']).isRequired,
    hideVisual: PropTypes.bool,
    condensed: PropTypes.bool,
    description: PropTypes.string
  }).isRequired,
  title: PropTypes.string
};

export default Calculators;
